import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getStore as getSearchStore } from '../store/Store';

/**
 * Return the friendly name (if available) or id of the currently selected folder.
 * If no folder is selected and not in search, return the staticFolderScopeId
 */
export const getSelectedFolderNameOrId = (): string => {
    const selectedFolder = getSelectedFolder();

    if (selectedFolder) {
        // We push a friendly name if it is a distinguished folder (ex: inbox, junkemail, etc.),
        // otherwise we push its folder id.
        const selectedFolderId = selectedFolder.FolderId.Id;
        return selectedFolder.distinguishedFolderId
            ? folderIdToName(selectedFolderId)
            : selectedFolderId;
    }

    return getListViewStore().shouldShowSearchBox ? getSearchStore().staticFolderScopeId : null;
};
